export class SubscriptionPermissions {
	constructor( {
		see = false,
		edit = false
	} ) {
		this.see = see;
		this.edit = edit;
	}
}

export const workspaceOwnerSubscriptionPermissions = new SubscriptionPermissions( {
	see: true, edit: true
} );
export const adminSubscriptionPermissions = new SubscriptionPermissions( {
	see: false, edit: false
} );
export const collaboratorSubscriptionPermissions = new SubscriptionPermissions( {
	see: false, edit: false
} );
